import { WorkingDays } from '../interfaces/working-days.interface';

export const defaultWorkingDays: WorkingDays = { mon: 1, tue: 1, wed: 1, thu: 1, fri: 1, sat: 0, sun: 0 };
